import React from "react";
import { Badge } from "../ui/badge";
import { AlertCircle, CheckCircle2, Clock } from "lucide-react";
import { cn } from "../ui/utils";

interface QualificationStatusBadgeProps {
  status: "Active" | "Expiring Soon" | "Expired";
  className?: string;
}

export const QualificationStatusBadge: React.FC<QualificationStatusBadgeProps> = ({ 
  status, 
  className 
}) => {
  switch (status) {
    case "Active":
      return (
        <Badge 
          variant="outline" 
          className={cn("bg-green-50 text-green-700 border-green-200 gap-1", className)}
        >
          <CheckCircle2 size={12} />
          Active
        </Badge>
      );
    case "Expiring Soon":
      return (
        <Badge 
          variant="outline" 
          className={cn("bg-orange-50 text-orange-700 border-orange-200 gap-1", className)}
        >
          <Clock size={12} />
          Expiring Soon
        </Badge>
      );
    case "Expired":
      return (
        <Badge 
          variant="outline" 
          className={cn("bg-red-50 text-red-700 border-red-200 gap-1", className)}
        >
          <AlertCircle size={12} />
          Expired
        </Badge>
      );
    default:
      return null;
  }
};
